import React from "react"
export function LeftChevronFill(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm1.028 3.599l-3.5 4a.75.75 0 00-.066.899l.066.089 3.5 4 1.13-.988-3.068-3.506 3.067-3.506-1.129-.988z"
        fill="currentColor"
        id="prefix__left-chevron---fill"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
